import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { PipesModule } from '@app/pipes';

@Component({
  selector: 'mnf-pi-v2-info-descriptions',
  standalone: true,
  imports: [CommonModule, PipesModule],
  templateUrl: './pi-v2-info-descriptions.component.html',
  styleUrl: './pi-v2-info-descriptions.component.scss'
})
export class PiV2InfoDescriptionsComponent {
  @Input() description: string;
  @Input() descriptionWarranty: string;
}
